import axios from 'axios'

export function fetchActiveShippingMethods() {
    return axios.get('/api/company/shipping-methods/active')
        .then((res) => {
            if (res.data.status === 'success') {
                return res.data.shipping_methods
            }

            return []
        })
        .catch(() => [])
}

export function shippingMethodsToFilterOptions(methods) {
    return methods.map((method) => ({
        id: method,
        label: method,
    }))
}
